import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseIllustrationLayout } from '../Layout';
const IllustrationLayout = forwardRef(({ children, ...props }, ref) => {
    return (_jsx(BaseIllustrationLayout, { ref: ref, ...props, children: children }));
});
export default IllustrationLayout;
